import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addFieldPracticeParticipations } from "services";

import { invalidateCarbonProgramQueriesByChunk, invalidateQueriesByChunk } from "utils";

import { ADD_FIELD_PRACTICE_PARTICIPATIONS, GET_FARM_DATA_SUBMISSION_STATUS, GET_FIELD_DETAILS, GET_FIELD_PRACTICES } from "consts";

export const useAddFieldPracticeParticipations = (fieldId: string, farmId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [ADD_FIELD_PRACTICE_PARTICIPATIONS],
    mutationFn: addFieldPracticeParticipations,
    onSuccess: () => {
      invalidateCarbonProgramQueriesByChunk(fieldId);
      invalidateQueriesByChunk(GET_FIELD_PRACTICES, fieldId);
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId] });
      // Field details need to be re-fetched to reflect possible exceeding of hectare limit
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_DETAILS] });
    },
  });
};
